export default __webpack_public_path__ + "static/media/tooltip-icon.bcb095e4.svg";